<!-- <div class="fixed-top custombg" style=" z-index: 100;">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div> -->
<div class="wrapper form_container">
  <div class="inprogress">
    <img src="../../../assets/images/EarlyPreview.png" height='35px' style="margin-left:'40px'" />
  </div>
  <div class="main-competency-edit-section">
    <div class="edit-section mx-0 row">

      <mat-card-content class="mx-0 my-0 p-0">
        <!-- People -->
        <mat-accordion>
          <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" expanded="true">
            <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
              <mat-panel-title class="h3 fw-500 field_heading">
                People
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="count">
              <p class="mb-0">Measuring Parameters</p>
            </div>
            <div class="service-areas mt-2 px-0 px-md-5 area_field_content" *ngFor="let item of People | keyvalue"
              style="font-size: 1.2rem;font-weight: bold;">
              {{item.key}}
              <div *ngFor="let i of item.value" class="col-12 px-0  ">
                <div class="area-header d-flex mt-1 mb-1 h5">
                  <div class="area-header-left">
                    <label class="col-10 px-0">{{i[0]}} &nbsp;
                    </label>

                  </div>

                  <div class="area-header-middle d-flex">
                    <div class="area-section">
                      <input type="checkbox" value="1" [checked]="i[1].length>=1 ? true : false " />
                    </div>

                    <div class="area-section">
                      <textarea>{{i[1]}}</textarea>
                    </div>
                    <div class="area-clear ">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- Governance -->
          <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions">
            <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
              <mat-panel-title class="h3 fw-500 field_heading">
                Governance
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="count">
              <p class="mb-0">Measuring Parameters</p>
            </div>
            <div class="service-areas mt-2 px-0 px-md-5 area_field_content" *ngFor="let item of Governance | keyvalue"
              style="font-size: 1.2rem;font-weight: bold;">
              {{item.key}}
              <div *ngFor="let i of item.value" class="col-12 px-0  ">
                <div class="area-header d-flex mt-1 mb-1 h5">
                  <div class="area-header-left">
                    <label class="col-10 px-0">{{i[0]}} &nbsp;
                    </label>
                  </div>

                  <div class="area-header-middle d-flex">
                    <div class="area-section">
                      <input type="checkbox" value="1" [checked]="i[1].length>=1 ? true : false " />
                    </div>

                    <div class="area-section">
                      <textarea>{{i[1]}}</textarea>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Marketing -->
          <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions">
            <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
              <mat-panel-title class="h3 fw-500 field_heading">
                Marketing
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="count">
              <p class="mb-0">Measuring Parameters</p>
            </div>
            <div class="service-areas mt-2 px-0 px-md-5 area_field_content" *ngFor="let item of Marketing | keyvalue"
              style="font-size: 1.2rem;font-weight: bold;">
              {{item.key}}
              <div *ngFor="let i of item.value" class="col-12 px-0  ">
                <div class="area-header d-flex mt-1 mb-1 h5">
                  <div class="area-header-left">
                    <label class="col-10 px-0">{{i[0]}} &nbsp;
                    </label>
                  </div>

                  <div class="area-header-middle d-flex">
                    <div class="area-section">
                      <input type="checkbox" value="1" [checked]="i[1].length>=1 ? true : false " />
                    </div>

                    <div class="area-section">
                      <textarea>{{i[1]}}</textarea>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Capabilities -->
          <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions">
            <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
              <mat-panel-title class="h3 fw-500 field_heading">
                Capabilities
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="count">
              <p class="mb-0">Measuring Parameters</p>
            </div>
            <div class="service-areas mt-2 px-0 px-md-5 area_field_content" *ngFor="let item of Capabilities | keyvalue"
              style="font-size: 1.2rem;font-weight: bold;">
              {{item.key}}
              <div *ngFor="let i of item.value" class="col-12 px-0  ">
                <div class="area-header d-flex mt-1 mb-1 h5">
                  <div class="area-header-left">
                    <label class="col-10 px-0">{{i[0]}} &nbsp;
                    </label>
                  </div>

                  <div class="area-header-middle d-flex">
                    <div class="area-section">
                      <input type="checkbox" value="1" [checked]="i[1].length>=1 ? true : false" />
                    </div>

                    <div class="area-section">
                      <textarea>{{i[1]}}</textarea>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>

      <div class="button_section my-3">
        <button class="btn custom_btn inverted_btn_base">Cancel</button>
        <button class="btn custom_btn primary_btn_base">Submit</button>
      </div>

    </div>
  </div>